import { DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelGlControl extends Layout {
    labelDrLocalFeeAdvanceOnly: Label;
    labelDrLocalFeeFuelAndAdvance: Label;
    labelLoLocalFeeAdvanceOnly: Label;
    labelLoLocalFeeFuelAndAdvance: Label;
    labelLoLocalFeeFuelOnly: Label;
    labelLocalAmountHeader: Label;
    labelLocalDeductionCodes: Label;
    labelLocalFeesHeader: Label;
    labelLocalOptionsHeader: Label;
    labelOwnerAmountHeader: Label;
    labelOwnerDeductionCodes: Label;
    labelOwnerFeesHeader: Label;
    labelOwnerOptionsHeader: Label;
    labelProducts: Label;
    panelCompanyDriverLocalFeesHeader: Panel;
    panelCompanyDriversGL: Panel;
    panelCompanyDriversLocalFeesFees: Panel;
    panelDataHeader: DataHeader;
    panelDrLocalFeeAdvanceOnly: Panel;
    panelDrLocalFeeFuelAndAdvance: Panel;
    panelLoLocalFeeAdvanceOnly: Panel;
    panelLoLocalFeeFuelAndAdvance: Panel;
    panelLoLocalFeeFuelOnly: Panel;
    panelOwnerLocalFeesHeader: Panel;
    panelOwnerOperatorsGL: Panel;
    panelOwnerOperatorsLocalFeesFees: Panel;
    panelProducts: Panel;
    sourceFuelExpense: DataSource;
    sourceFuelProdGlAccount: DataSource;
    switchCompanyLocalHold: Switch;
    switchOwnerHold: Switch;
    switchSwitchUpdateOrder: Switch;
    switchTractorNumber: Switch;
    tabCompanyDriver: Tab;
    tabOwnerOperator: Tab;
    tableProducts: Table;
    tabsetFuelGLControl: Tabset;
    textboxDrAdvanceGlid: Textbox;
    textboxDrDeductCodeId: Textbox;
    textboxDrDefDiscGlid: Textbox;
    textboxDrDiscountGlid: Textbox;
    textboxDrLocalFeeAdvOnlyCode: Textbox;
    textboxDrLocalFeeAdvOnlyFee: Textbox;
    textboxDrLocalFeeFuelAdvCode: Textbox;
    textboxDrLocalFeeFuelAdvFee: Textbox;
    textboxDrLocalFeeGlid: Textbox;
    textboxDrMiscExpGlid: Textbox;
    textboxDrOilGlid: Textbox;
    textboxDrOtherDiscGlid: Textbox;
    textboxDrOtherFuelGlid: Textbox;
    textboxDrPumpDefGlid: Textbox;
    textboxDrReefFuelGlid: Textbox;
    textboxDrReeferDiscGlid: Textbox;
    textboxDrRepairGlid: Textbox;
    textboxDrTireGlid: Textbox;
    textboxDrTractFuelGlid: Textbox;
    textboxId: Textbox;
    textboxIdDesc: Textbox;
    textboxLoAdvanceGlid: Textbox;
    textboxLoDeductCodeId: Textbox;
    textboxLoDefDiscGlid: Textbox;
    textboxLoDiscountGlid: Textbox;
    textboxLoFuelDedCode: Textbox;
    textboxLoLocalFeeAdvOnlyCode: Textbox;
    textboxLoLocalFeeAdvOnlyFee: Textbox;
    textboxLoLocalFeeFuelAdvCode: Textbox;
    textboxLoLocalFeeFuelAdvFee: Textbox;
    textboxLoLocalFeeFuelOnlyCode: Textbox;
    textboxLoLocalFeeFuelOnlyFee: Textbox;
    textboxLoLocalFeeGlid: Textbox;
    textboxLoMiscExpGlid: Textbox;
    textboxLoOilGlid: Textbox;
    textboxLoOtherDiscGlid: Textbox;
    textboxLoOtherFuelGlid: Textbox;
    textboxLoPumpDefGlid: Textbox;
    textboxLoReefFuelGlid: Textbox;
    textboxLoReeferDiscGlid: Textbox;
    textboxLoRepairGlid: Textbox;
    textboxLoTireGlid: Textbox;
    textboxLoTractFuelGlid: Textbox;
}
